export default __webpack_public_path__ + "static/media/download_report.6bfb17f8.svg";